<template>
  <transition name="dialog">
    <div class="m-dialog" :style="{ zIndex: zIndex }" v-show="visible" ref="dialogRoot">
      <div class="dialog-mask" @click="handleMaskClick"></div>
      <div class="dialog-container">
        <!-- 关闭按钮 -->
        <div class="close-btn" @click="handleClose" v-if="showClose"></div>

        <!-- 标题 -->
        <div class="dialog-title" v-if="title">{{ title }}</div>

        <!-- 内容区域 -->
        <div class="dialog-content" :class="contentClass" ref="dialogContent">
          <slot></slot>
        </div>

        <!-- 底部按钮 -->
        <div class="dialog-footer" v-if="showFooter">
          <slot name="footer">
            <div class="btn primary-btn" @click="handleConfirm">{{ confirmText }}</div>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { lock, unlock } from 'tua-body-scroll-lock';

export default {
  name: 'MDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: [String, Object, Array],
      default: ''
    },
    zIndex: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      originalParent: null
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.$nextTick(() => {
          lock(this.$refs.dialogContent);
        });
      } else {
        unlock();
      }
    },
    appendToBody: {
      handler(val) {
        if (this.$refs.dialogRoot) {
          if (val) {
            this.moveToBody();
          } else {
            this.moveBack();
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    if (this.value) {
      this.$nextTick(() => {
        lock(this.$refs.dialogContent);
      });
    }
    
    if (this.appendToBody) {
      this.moveToBody();
    }
  },
  beforeDestroy() {
    if (this.appendToBody && this.$refs.dialogRoot && this.$refs.dialogRoot.parentNode === document.body) {
      document.body.removeChild(this.$refs.dialogRoot);
    }
    unlock();
  },
  methods: {
    handleClose() {
      this.visible = false
      this.$emit('close')
    },
    handleMaskClick() {
      if (this.maskClosable) {
        this.handleClose()
      }
    },
    handleConfirm() {
      this.$emit('confirm')
    },
    moveToBody() {
      const el = this.$refs.dialogRoot;
      if (el && el.parentNode !== document.body) {
        this.originalParent = el.parentNode;
        document.body.appendChild(el);
      }
    },
    moveBack() {
      const el = this.$refs.dialogRoot;
      if (el && this.originalParent && el.parentNode === document.body) {
        this.originalParent.appendChild(el);
      }
    }
  }
}
</script>

<style lang="less">
@import './index.less';
</style>
